export const getSource = isOverflow => {
  return isOverflow ? 'overflow button' : 'activity button';
};
export default getSource;